export default __webpack_public_path__ + "static/media/guide-background.12a9d620.jpeg";